/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type ProfileImportItemRetryAction = typeof ProfileImportItemRetryAction[keyof typeof ProfileImportItemRetryAction] | null;


export const ProfileImportItemRetryAction = {
  retry: 'retry',
  reupload: 'reupload',
  none: 'none',
} as const;
